import TaskEntityContent from '@/components/entity-detail/components/Entity/TaskEntity';
import type { TDetailServiceParams } from '@/components/entity-detail/types/EntityType.types';
import { TASK_CHECK_PARAMS } from '@/constants/query-params/task-check.constant';
import { taskCheckService } from '@/services/rest';
import type { TaskCheckResponse } from '@/types/apps/task-check.type';
import type { ApiResponse } from '@/types/common/api.type';
import { t } from '@/utils/lang';
import { Entity } from '../entity';

export class TaskEntity extends Entity {
    public getTitleTemplate(response?: string): string {
        if (!response) {
            return t('Task');
        }

        return `${t('Task')}: ${this.getTitle(response)}`;
    }

    public getEntityComponent(): any {
        return TaskEntityContent;
    }

    public getIncludeProperties() {
        return TASK_CHECK_PARAMS;
    }

    public getDetailService(
        params: TDetailServiceParams
    ): Promise<ApiResponse<TaskCheckResponse>> {
        return taskCheckService().detail(params.id, {
            ...this.getIncludeProperties(),
            ...params,
        });
    }

    public getFieldName(): string {
        return 'name';
    }

    public getDetailUrl(id: string): string {
        return this.routeManager.getRouteMap()[this.getRouteDetail()].path(id);
    }

    public showDetailButton(): boolean {
        return true;
    }

    public getRouteDetail(): string {
        return this.routeManager.TASK_DETAIL;
    }
}
